export default __webpack_public_path__ + "static/media/agreement.14a64855.png";